import { defineComponent, h, type Component } from 'vue'
import GeneralLayout from '@/components/layouts/GeneralLayout.vue'

/**
 * Wrapper pour appliquer le GeneralLayout à un composant
 * @param component - Le composant Vue à wrapper
 * @returns Le composant wrappé avec GeneralLayout
 */
export function withGeneralLayout(component: Component) {
  return defineComponent({
    name: 'WithGeneralLayout',
    setup() {
      return () => h(GeneralLayout, {}, { default: () => h(component) })
    }
  })
}

